import { render, staticRenderFns } from "./AdjustableImageButtons.vue?vue&type=template&id=4db89394&scoped=true"
import script from "./AdjustableImageButtons.vue?vue&type=script&lang=ts"
export * from "./AdjustableImageButtons.vue?vue&type=script&lang=ts"
import style0 from "./AdjustableImageButtons.vue?vue&type=style&index=0&id=4db89394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db89394",
  null
  
)

/* custom blocks */
import block0 from "./AdjustableImageButtons.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports